var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1835 3.21662C19.0946 2.3054 20.5721 2.3054 21.4833 3.21662L24.7831 6.51645C25.6943 7.42767 25.6943 8.90506 24.7831 9.81628L21.4833 13.1161C20.5721 14.0273 19.0946 14.0273 18.1835 13.1161L14.8837 9.81628C13.9724 8.90506 13.9724 7.42767 14.8837 6.51645L18.1835 3.21662ZM19.8334 4.86653L16.5336 8.16637L19.8334 11.4662L23.1332 8.16637L19.8334 4.86653Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3.5C11.7887 3.5 12.8333 4.54467 12.8333 5.83333V10.5C12.8333 11.7887 11.7887 12.8333 10.5 12.8333H5.83333C4.54467 12.8333 3.5 11.7887 3.5 10.5V5.83333C3.5 4.54467 4.54467 3.5 5.83333 3.5H10.5ZM10.5 5.83333H5.83333V10.5H10.5V5.83333ZM24.5 17.5C24.5 16.2113 23.4554 15.1667 22.1667 15.1667H17.5C16.2113 15.1667 15.1667 16.2113 15.1667 17.5V22.1667C15.1667 23.4554 16.2113 24.5 17.5 24.5H22.1667C23.4554 24.5 24.5 23.4554 24.5 22.1667V17.5ZM22.1667 17.5V22.1667H17.5V17.5H22.1667ZM10.5 15.1667C11.7887 15.1667 12.8333 16.2113 12.8333 17.5V22.1667C12.8333 23.4554 11.7887 24.5 10.5 24.5H5.83333C4.54467 24.5 3.5 23.4554 3.5 22.1667V17.5C3.5 16.2113 4.54467 15.1667 5.83333 15.1667H10.5ZM10.5 17.5H5.83333V22.1667H10.5V17.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.204252d076c222616c2b3721721cd498.svg";
export { ForwardRef as ReactComponent };